<template>
  <!--专题管理-->
  <div class="lanmu_cont">
    <div class="layui-card-header">
      <button type="button" class="layui-btn layui-btn-sm btn_r" @click="addNewToplan">新增栏目</button>
    </div>
    <el-table id="lanmuData" :data="lanmuData" style="width: 100%;margin-bottom: 20px;" row-key="id" border :tree-props="{children: 'list', hasChildren: 'hasChildren'}" default-expand-all v-loading="lanmuloading">
      <el-table-column align="center" label="序列" width="80">
        <template slot-scope="scope">
          <template v-if="scope.row.pid != 0">└─</template>
        </template>
      </el-table-column>
      <el-table-column align="center" label="排序" width="80">
        <template slot-scope="scope">
          <input type="text" v-model="scope.row.list_order">
        </template>
      </el-table-column>
      <el-table-column prop="id" align="center" label="ID" width="80">
      </el-table-column>
      <el-table-column prop="title" align="center" label="栏目名" width="180">
      </el-table-column>
      <el-table-column prop="typeStr" align="center" label="栏目类型" width="180"></el-table-column>
      <el-table-column label="状态" align="center" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">正常</span>
          <span v-if="scope.row.status == 0">关闭</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
          <el-button size="mini" v-if="scope.row.pid == 0 && scope.row.type == 15" type="danger" @click="addZilanmu(scope.row.id)">新增子栏目</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px">
      <el-button @click="reachLanmu">更新排序</el-button>
    </div>



    <!--弹框部分-->
    <!--新增栏目-->
      <el-dialog :title="lanmubox.pid =='' ?'新增栏目':'新增子栏目'" :visible.sync="lanmuDialog" :modal-append-to-body="false" :close-on-click-modal="false"  width="700px">
          <div class="lanmu_box">
            <el-form   :model="lanmubox" label-width="120px" :rules="lmrules" ref="lanmubox">
              <el-form-item label="栏目类型" prop="type">
                <el-select v-model="lanmubox.type" placeholder="请选择栏目类型">
                  <template v-for="(items,index) in lanmuTyleList">
                    <el-option v-if="items.status" :label="items.name" :value="items.id"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="栏目名称" prop="name">
                <el-input v-model="lanmubox.name"></el-input>
              </el-form-item>
              <el-form-item label="栏目图(未选中)" prop="no_select_img">
                <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile4" auto-upload list-type="picture-card" style="overflow:hidden;">
                  <img :src="no_select_img" style="width:100%;height:100%;" v-if="no_select_img != ''">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <!--<button type="button" class="layui-btn layui-btn-sm " v-if="no_select_img != ''" style="margin-left:30px;" @click="removeImg('no_select_img')">清除封面</button>-->
                <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：高度1：1宽度 </p>
              </el-form-item>
              <el-form-item label="栏目图(选中)" prop="select_img">
                <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile3" auto-upload list-type="picture-card" style="overflow:hidden;">
                  <img :src="select_img" style="width:100%;height:100%;" v-if="select_img != ''">
                  <i class="el-icon-plus"></i>
                </el-upload>
              <!--  <button type="button" class="layui-btn layui-btn-sm " v-if="select_img != ''" style="margin-left:30px;" @click="removeImg('select_img')">清除封面</button>-->
                <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：高度1：1宽度 </p>
              </el-form-item>
              <el-form-item label="状态" prop="status">
                <el-radio-group v-model="lanmubox.status">
                  <el-radio label="1">正常</el-radio>
                  <el-radio label="0">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item style="text-align:center;">
                <button  type="button"  class="layui-btn" style="margin-left:-65px;" @click="addlanmupost" >保存</button>
              </el-form-item>
            </el-form>
          </div>
        </el-dialog>

    <!--编辑顶级栏目-->
    <el-dialog title="修改顶级栏目" :visible.sync="changeDjDialog" :modal-append-to-body="false" :close-on-click-modal="false"  width="700px">
          <div class="lanmu_box">
            <el-form   :model="djdata" label-width="120px" :rules="lmrules" ref="changeDbox">
              <el-form-item label="栏目类型" prop="type">
                <el-select v-model="djdata.type" placeholder="请选择栏目类型" disabled>
                  <template v-for="(items,index) in lanmuTyleList">
        <el-option v-if="items.status" :label="items.name" :value="items.id"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="栏目名称" prop="title">
                <el-input v-model="djdata.title"></el-input>
              </el-form-item>
              <el-form-item label="栏目图(未选中)" prop="no_select_img">
                <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile4" auto-upload list-type="picture-card" style="overflow:hidden;">
                  <img :src="no_select_img" style="width:100%;height:100%;" v-if="no_select_img != ''">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <!--<button type="button" class="layui-btn layui-btn-sm " v-if="no_select_img != ''" style="margin-left:30px;" @click="removeImg('no_select_img')">清除封面</button>-->
                <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：高度1：1宽度 </p>
              </el-form-item>
              <el-form-item label="栏目图(选中)" prop="select_img">
                <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile3" auto-upload list-type="picture-card" style="overflow:hidden;">
                  <img :src="select_img" style="width:100%;height:100%;" v-if="select_img != ''">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <!--  <button type="button" class="layui-btn layui-btn-sm " v-if="select_img != ''" style="margin-left:30px;" @click="removeImg('select_img')">清除封面</button>-->
                <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：高度1：1宽度 </p>
              </el-form-item>
              <el-form-item label="状态" prop="status">
                <el-radio-group v-model="djdata.status">
                  <el-radio label="1">正常</el-radio>
                  <el-radio label="0">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item style="text-align:center;">
                <button  type="button"  class="layui-btn" style="margin-left:-65px;"  @click="changeDJ" >保存</button>
              </el-form-item>
            </el-form>
          </div>
        </el-dialog>

      <!--直播栏目-->
      <el-dialog title="编辑直播" :visible.sync="changezhiboDialog" :modal-append-to-body="false" :close-on-click-modal="false" width="700px">
              <div class="lanmu_box">
                <el-form   :model="zhibodata" label-width="120px" :rules="zhiborules" ref="zhibodata">
                  <el-form-item label="栏目类型" prop="type">
                    <el-select v-model="zhibodata.type" placeholder="请选择栏目类型" disabled>
                      <template v-for="(items,index) in lanmuTyleList">
                        <el-option v-if="items.status" :label="items.name" :value="items.id"></el-option>
                      </template>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="栏目名称" prop="title">
                    <el-input v-model="zhibodata.title"></el-input>
                  </el-form-item>
                  <el-form-item label="栏目图(未选中)" prop="no_select_img">
                    <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile4" auto-upload list-type="picture-card" style="overflow:hidden;">
                      <img :src="no_select_img" style="width:100%;height:100%;" v-if="no_select_img != ''">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <!--<button type="button" class="layui-btn layui-btn-sm " v-if="no_select_img != ''" style="margin-left:30px;" @click="removeImg('no_select_img')">清除封面</button>-->
                    <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：高度1：1宽度 </p>
                  </el-form-item>
                  <el-form-item label="栏目图(选中)" prop="select_img">
                    <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile3" auto-upload list-type="picture-card" style="overflow:hidden;">
                      <img :src="select_img" style="width:100%;height:100%;" v-if="select_img != ''">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <!--  <button type="button" class="layui-btn layui-btn-sm " v-if="select_img != ''" style="margin-left:30px;" @click="removeImg('select_img')">清除封面</button>-->
                    <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：高度1：1宽度 </p>
                  </el-form-item>
                  <el-form-item label="栏目状态" prop="status">
                    <el-radio-group v-model="zhibodata.status">
                      <el-radio label="1">正常</el-radio>
                      <el-radio label="0">禁用</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="是否隐藏标题"  prop="isTitleHide">
                    <el-radio-group v-model="zhibodata.isTitleHide">
                      <el-radio label="1">显示</el-radio>
                      <el-radio label="0">隐藏</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="直播状态"  prop="is_full">
                    <el-radio-group v-model="zhibodata.is_full">
                      <el-radio label="1">待开始</el-radio>
                      <el-radio label="2">直播中</el-radio>
                      <el-radio label="3">已结束</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="直播方式">
                    <el-radio-group v-model="zhibodata.is_public">
                      <el-radio label="1">图片跳转链接</el-radio>
                      <!--<el-radio label="2">第三方视频链接</el-radio>-->
                      <el-radio label="3">iframe引入</el-radio>
                      <el-radio label="4">选择视频</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="图片跳转链接" v-if="zhibodata.is_public == '1'">
                    <el-input v-model="zhibodata.jump_url"></el-input>
                  </el-form-item>
                  <el-form-item label="第三方视频链接"  v-if="zhibodata.is_public == '2'">
                    <el-input v-model="zhibodata.file_url"></el-input>
                  </el-form-item>
                  <el-form-item label="iframe引入" v-if="zhibodata.is_public == '3'">
                    <el-input type="textarea" v-model="zhibodata.content"></el-input>
                  </el-form-item>
                  <el-form-item label="视频选择" v-if="zhibodata.is_public == '4'">
                    <el-table :data="videoList"   border style="width: 100%">
                      <el-table-column  align="center" label="序号" width="100">
                        <template slot-scope="scope">
                            <el-radio v-model="zhibodata.video_id" :label="scope.row.id">{{scope.$index+1}}</el-radio>
                         </template>
                      </el-table-column>
                      <el-table-column prop="id"  align="center" label="ID" width="100"></el-table-column>
                      <el-table-column prop="title" label="名称">
                      </el-table-column>
                    </el-table>
                  </el-form-item>
                  <el-form-item label="直播待开始封面" prop="video_cover_url" >
                    <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile" auto-upload  list-type="picture-card"  style="overflow:hidden;">
                      <img :src="zhibodata.video_cover_url" style="width:100%;height:100%;" v-if="zhibodata.video_cover_url != ''">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <button  type="button"  class="layui-btn layui-btn-sm " v-if="zhibodata.video_cover_url != ''" style="margin-left:30px;"  @click="removeImg('video_cover_url')">清除封面</button>
                    <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：高度1：1宽度 </p>
                  </el-form-item>
                  <el-form-item label="直播中封面"  prop="author">
                    <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile2" auto-upload  list-type="picture-card"  style="overflow:hidden;">
                      <img :src="zhibodata.author" style="width:100%;height:100%;" v-if="zhibodata.author != ''">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <button  type="button"  class="layui-btn layui-btn-sm " v-if="zhibodata.author != ''" style="margin-left:30px;"  @click="removeImg('author')">清除封面</button>
                    <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：高度1：1宽度 </p>
                  </el-form-item>
                    <el-form-item style="text-align:center;">
                    <button  type="button"  class="layui-btn" style="margin-left:-65px;"  @click="saveZhibo" >保存</button>
                  </el-form-item>
                </el-form>
              </div>
            </el-dialog>

      <!--编辑议程-->
      <el-dialog title="编辑议程" :visible.sync="yichengDialog" :modal-append-to-body="false" :close-on-click-modal="false" width="700px">
        <div class="lanmu_box">
          <el-form   :model="yichengdata" label-width="120px" :rules="yichengrules" ref="yichengdata">
            <el-form-item label="栏目类型" prop="type">
              <el-select v-model="yichengdata.type" placeholder="请选择栏目类型" disabled>
                <template v-for="(items,index) in lanmuTyleList">
      <el-option v-if="items.status" :label="items.name" :value="items.id"></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="栏目名称" prop="title">
              <el-input v-model="yichengdata.title"></el-input>
            </el-form-item>
            <el-form-item label="栏目图(未选中)" prop="no_select_img">
              <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile4" auto-upload list-type="picture-card" style="overflow:hidden;">
                <img :src="no_select_img" style="width:100%;height:100%;" v-if="no_select_img != ''">
                <i class="el-icon-plus"></i>
              </el-upload>
              <!--<button type="button" class="layui-btn layui-btn-sm " v-if="no_select_img != ''" style="margin-left:30px;" @click="removeImg('no_select_img')">清除封面</button>-->
              <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：高度1：1宽度 </p>
            </el-form-item>
            <el-form-item label="栏目图(选中)" prop="select_img">
              <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile3" auto-upload list-type="picture-card" style="overflow:hidden;">
                <img :src="select_img" style="width:100%;height:100%;" v-if="select_img != ''">
                <i class="el-icon-plus"></i>
              </el-upload>
              <!--  <button type="button" class="layui-btn layui-btn-sm " v-if="select_img != ''" style="margin-left:30px;" @click="removeImg('select_img')">清除封面</button>-->
              <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：高度1：1宽度 </p>
            </el-form-item>
            <el-form-item label="栏目状态" prop="status">
              <el-radio-group v-model="yichengdata.status">
                <el-radio label="1">正常</el-radio>
                <el-radio label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否隐藏标题"  prop="isTitleHide">
              <el-radio-group v-model="yichengdata.isTitleHide">
                <el-radio label="1">显示</el-radio>
                <el-radio label="0">隐藏</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="议程展示方式">
              <el-radio-group v-model="yichengdata.is_public">
                <el-radio label="1">图文</el-radio>
                <el-radio label="2">格式列表</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="议程状态">
              <el-radio-group v-model="yichengdata.agenda_status">
                <el-radio label="0">未开始</el-radio>
                <el-radio label="1">进行中</el-radio>
                <el-radio label="2">已结束</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="图文" prop="content" v-if="yichengdata.is_public == 1">
              <div class="vueueditor">
                <vue-ueditor-wrap  v-model="yichengdata.content" :config="myConfig"></vue-ueditor-wrap>
              </div>
            </el-form-item>
            <el-form-item label="列表" prop="desc" v-if="yichengdata.is_public == 2">
              <div class="layui-card-header">
                <button type="button" class="layui-btn layui-btn-sm btn_r" @click="yichengAddshow">新增</button>
              </div>
              <el-table :data="yichengdata.desc" border style="width: 100%">
                <el-table-column prop="type" align="center" label="类型" width="100">
                  <template slot-scope="scope">
                      <template v-if="scope.row.type == '1'">天</template>
                      <template v-if="scope.row.type == '2'">时间段</template>
                  </template>
                </el-table-column>
               <el-table-column prop="times" align="center" label="时间">
                </el-table-column>
                <el-table-column prop="info" label="内容">
                  <template slot-scope="scope">
                    <template v-if="scope.row.type == '1'">---</template>
                  <template v-if="scope.row.type == '2'">{{scope.row.info}}</template>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="160">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="changeYCadd(scope.$index)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="removeYCadd(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
            <el-form-item style="text-align:center;">
              <button  type="button"  class="layui-btn" style="margin-left:-65px;"  @click="saveYicheng" >保存</button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
     <!--议程列表新增-->
     <el-dialog title="新增" :visible.sync="yichengaddDialog" :modal-append-to-body="false" :close-on-click-modal="false">
            <div class="addjiben_box">
              <el-form   :model="yichengadd" label-width="130px" :rules="yichengaddrules" ref="yichengadd">
                <el-form-item label="类型" prop="type">
                  <el-select v-model="yichengadd.type" placeholder="请选择类型">
                    <el-option label="天" value="1"></el-option>
                    <el-option label="时间段" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="时间" prop="times">
                  <el-input v-model="yichengadd.times"></el-input>
                </el-form-item>
                <el-form-item label="内容" prop="info" v-if="yichengadd.type == '2'">
                  <el-input type="textarea" v-model="yichengadd.info"></el-input>
                </el-form-item>
                <el-form-item style="text-align:center;">
                  <button  type="button"  class="layui-btn" style="margin-left:-65px;"  @click="yichengAddSave()">保存</button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>


        <!--值 20   合作机构-->
      <el-dialog title="编辑" :visible.sync="zhiboxDialog" :modal-append-to-body="false" :close-on-click-modal="false" width="700px">
        <div class="lanmu_box">
          <el-form :model="zhiboxdata" label-width="120px" :rules="zhiboxrules" ref="zhiboxdata">
            <el-form-item label="栏目类型" prop="type">
              <el-select v-model="zhiboxdata.type" placeholder="请选择栏目类型" disabled>
                <template v-for="(items,index) in lanmuTyleList">
                  <el-option v-if="items.status" :label="items.name" :value="items.id"></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="栏目名称" prop="title">
              <el-input v-model="zhiboxdata.title"></el-input>
            </el-form-item>
            <el-form-item label="栏目图(未选中)" prop="no_select_img">
              <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile4" auto-upload list-type="picture-card" style="overflow:hidden;">
                <img :src="no_select_img" style="width:100%;height:100%;" v-if="no_select_img != ''">
                <i class="el-icon-plus"></i>
              </el-upload>
              <!--<button type="button" class="layui-btn layui-btn-sm " v-if="no_select_img != ''" style="margin-left:30px;" @click="removeImg('no_select_img')">清除封面</button>-->
              <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：高度1：1宽度 </p>
            </el-form-item>
            <el-form-item label="栏目图(选中)" prop="select_img">
              <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile3" auto-upload list-type="picture-card" style="overflow:hidden;">
                <img :src="select_img" style="width:100%;height:100%;" v-if="select_img != ''">
                <i class="el-icon-plus"></i>
              </el-upload>
              <!--  <button type="button" class="layui-btn layui-btn-sm " v-if="select_img != ''" style="margin-left:30px;" @click="removeImg('select_img')">清除封面</button>-->
              <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：高度1：1宽度 </p>
            </el-form-item>
            <el-form-item label="栏目状态" prop="status">
              <el-radio-group v-model="zhiboxdata.status">
                <el-radio label="1">正常</el-radio>
                <el-radio label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否隐藏标题" prop="isTitleHide">
              <el-radio-group v-model="zhiboxdata.isTitleHide">
                <el-radio label="1">显示</el-radio>
                <el-radio label="0">隐藏</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="列表" prop="desc">
              <div class="layui-card-header">
                <button type="button" class="layui-btn layui-btn-sm btn_r" @click="zhiboxAddShow">新增</button>
              </div>
              <el-table :data="zhiboxdata.desc" border style="width: 100%">
                <el-table-column prop="name" align="center" label="名称">
                </el-table-column>
                <el-table-column prop="link" label="链接">
                </el-table-column>
                <el-table-column align="center" label="操作" width="160">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="changezhibox(scope.$index)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="removezhibox(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
            <el-form-item style="text-align:center;">
              <button type="button" class="layui-btn" style="margin-left:-65px;" @click="savezhibox">保存</button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
       <!--合作机构新增-->
      <el-dialog title="新增" :visible.sync="zhiboxaddDialog" :modal-append-to-body="false" :close-on-click-modal="false" width="400px">
        <div class="addjiben_box">
          <el-form   :model="zhiboxadd" label-width="60px" :rules="zhiboxaddrules" ref="zhiboxadd">
            <el-form-item label="名称" prop="name">
              <el-input v-model="zhiboxadd.name"></el-input>
            </el-form-item>
            <el-form-item label="链接">
              <el-input   v-model="zhiboxadd.link"></el-input>
            </el-form-item>
            <el-form-item style="text-align:center;">
              <button  type="button"  class="layui-btn" style="margin-left:-65px;"  @click="zhiboxAddsave">保存</button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>

      <!--关联嘉宾-->
      <el-dialog title="关联嘉宾" :visible.sync="jiabinboxDialog" :modal-append-to-body="false" :close-on-click-modal="false" width="850px">
        <div class="lanmu_box">
          <el-form :model="jiabinboxdata" label-width="120px" :rules="jiabinboxrules" ref="jiabinboxdata">
            <el-form-item label="栏目类型" prop="type">
              <el-select v-model="jiabinboxdata.type" placeholder="请选择栏目类型" disabled>
                <template v-for="(items,index) in lanmuTyleList">
      <el-option v-if="items.status" :label="items.name" :value="items.id"></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="栏目名称" prop="title">
              <el-input v-model="jiabinboxdata.title"></el-input>
            </el-form-item>
            <el-form-item label="栏目图(未选中)" prop="no_select_img">
              <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile4" auto-upload list-type="picture-card" style="overflow:hidden;">
                <img :src="no_select_img" style="width:100%;height:100%;" v-if="no_select_img != ''">
                <i class="el-icon-plus"></i>
              </el-upload>
              <!--<button type="button" class="layui-btn layui-btn-sm " v-if="no_select_img != ''" style="margin-left:30px;" @click="removeImg('no_select_img')">清除封面</button>-->
              <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：高度1：1宽度 </p>
            </el-form-item>
            <el-form-item label="栏目图(选中)" prop="select_img">
              <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile3" auto-upload list-type="picture-card" style="overflow:hidden;">
                <img :src="select_img" style="width:100%;height:100%;" v-if="select_img != ''">
                <i class="el-icon-plus"></i>
              </el-upload>
              <!--  <button type="button" class="layui-btn layui-btn-sm " v-if="select_img != ''" style="margin-left:30px;" @click="removeImg('select_img')">清除封面</button>-->
              <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：高度1：1宽度 </p>
            </el-form-item>
            <el-form-item label="栏目状态" prop="status">
              <el-radio-group v-model="jiabinboxdata.status">
                <el-radio label="1">正常</el-radio>
                <el-radio label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否隐藏标题" prop="isTitleHide">
              <el-radio-group v-model="jiabinboxdata.isTitleHide">
                <el-radio label="1">显示</el-radio>
                <el-radio label="0">隐藏</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="嘉宾列表" prop="guest_ids">
              <el-checkbox-group v-model="jiabinboxdata.guest_ids">
                <el-table :data="jiabinlistbox.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))" border style="width: 100%" height="350">
                  <el-table-column width="70"  align="center" fixed label="序号">
                  <template slot-scope="scope" >
                    <el-checkbox :label="scope.row.id">{{scope.$index+1}}
                    </el-checkbox>
                  </template>
                </el-table-column>
                  <el-table-column width="70"  align="center" fixed label="排序">
                    <template slot-scope="scope">
                        <el-input v-model="jiabinPaixu[scope.$index]"></el-input>
                      </el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column width="175" fixed prop="name"  label="姓名">
                    <template slot="header" slot-scope="scope">
                       <el-input v-model="search" size="mini"  placeholder="输入姓名搜索" />
                    </template>
                </el-table-column>
                <el-table-column prop="tel" width="130"  align="center" label="电话" >
                </el-table-column>
                <el-table-column prop="ssapid" width="130" align="center" label="ssapid" >
                </el-table-column>
                <el-table-column prop="description" width="500"  align="center" label="简介">
                  <template slot-scope="scope" >
                        {{scope.row.description | ellipsis}}
                  </template>
                </el-table-column>
              </el-table>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item style="text-align:center;">
              <button type="button" class="layui-btn" style="margin-left:-65px;" @click="savejiabinbox">保存</button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>

       <!--关联资讯-->
      <el-dialog title="编辑资讯" :visible.sync="zixunboxDialog" :modal-append-to-body="false" :close-on-click-modal="false" width="850px">
        <div class="lanmu_box">
          <el-form :model="zixunboxdata" label-width="120px" :rules="zixunboxrules" ref="zixunboxdata">
            <el-form-item label="栏目类型" prop="type">
              <el-select v-model="zixunboxdata.type" placeholder="请选择栏目类型" disabled>
                <template v-for="(items,index) in lanmuTyleList">
                  <el-option v-if="items.status" :label="items.name" :value="items.id"></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="栏目名称" prop="title">
              <el-input v-model="zixunboxdata.title"></el-input>
            </el-form-item>
            <el-form-item label="栏目图(未选中)" prop="no_select_img">
              <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile4" auto-upload list-type="picture-card" style="overflow:hidden;">
                <img :src="no_select_img" style="width:100%;height:100%;" v-if="no_select_img != ''">
                <i class="el-icon-plus"></i>
              </el-upload>
              <!--<button type="button" class="layui-btn layui-btn-sm " v-if="no_select_img != ''" style="margin-left:30px;" @click="removeImg('no_select_img')">清除封面</button>-->
              <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：高度1：1宽度 </p>
            </el-form-item>
            <el-form-item label="栏目图(选中)" prop="select_img">
              <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile3" auto-upload list-type="picture-card" style="overflow:hidden;">
                <img :src="select_img" style="width:100%;height:100%;" v-if="select_img != ''">
                <i class="el-icon-plus"></i>
              </el-upload>
              <!--  <button type="button" class="layui-btn layui-btn-sm " v-if="select_img != ''" style="margin-left:30px;" @click="removeImg('select_img')">清除封面</button>-->
              <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：高度1：1宽度 </p>
            </el-form-item>
            <el-form-item label="栏目状态" prop="status">
              <el-radio-group v-model="zixunboxdata.status">
                <el-radio label="1">正常</el-radio>
                <el-radio label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否隐藏标题" prop="isTitleHide">
              <el-radio-group v-model="zixunboxdata.isTitleHide">
                <el-radio label="1">显示</el-radio>
                <el-radio label="0">隐藏</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="展示方式" prop="is_public">
              <el-radio-group v-model="zixunboxdata.is_public">
                <el-radio label="0">图文</el-radio>
                <el-radio label="1">列表</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="资讯列表" prop="file_ids">
              <el-checkbox-group v-model="zixunboxdata.file_ids">
                <el-table :data="zixunlistbox.filter(data => !zxsearch || data.name.toLowerCase().includes(zxsearch.toLowerCase()))" border style="width: 100%" height="350">
                  <el-table-column width="80" label="序号">
                    <template slot-scope="scope">
                      <el-checkbox :label="scope.row.id">{{scope.$index+1}}</el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column prop="id" width="80" align="center" label="ID">
                  </el-table-column>
                  <el-table-column  prop="name" label="名称">
                    <template slot="header" slot-scope="scope">
                    <el-input v-model="zxsearch" size="mini" placeholder="输入名称搜索" />
                    </template>
                  </el-table-column>
                  <el-table-column prop="author" width="130" align="center" label="作者">
                  </el-table-column>
                </el-table>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item style="text-align:center;">
              <button type="button" class="layui-btn" style="margin-left:-65px;" @click="savezixunbox">保存</button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>

      <!--关联视频-->
      <el-dialog title="编辑视频" :visible.sync="videoboxDialog" :modal-append-to-body="false" :close-on-click-modal="false" width="850px">
          <div class="lanmu_box">
            <el-form :model="videoboxdata" label-width="120px" :rules="videoboxrules" ref="videoboxdata">
              <el-form-item label="栏目类型" prop="type">
                <el-select v-model="videoboxdata.type" placeholder="请选择栏目类型" disabled>
                  <template v-for="(items,index) in lanmuTyleList">
                    <el-option v-if="items.status" :label="items.name" :value="items.id"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="栏目名称" prop="title">
                <el-input v-model="videoboxdata.title"></el-input>
              </el-form-item>
              <el-form-item label="栏目图(未选中)" prop="no_select_img">
                <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile4" auto-upload list-type="picture-card" style="overflow:hidden;">
                  <img :src="no_select_img" style="width:100%;height:100%;" v-if="no_select_img != ''">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <!--<button type="button" class="layui-btn layui-btn-sm " v-if="no_select_img != ''" style="margin-left:30px;" @click="removeImg('no_select_img')">清除封面</button>-->
                <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：高度1：1宽度 </p>
              </el-form-item>
              <el-form-item label="栏目图(选中)" prop="select_img">
                <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile3" auto-upload list-type="picture-card" style="overflow:hidden;">
                  <img :src="select_img" style="width:100%;height:100%;" v-if="select_img != ''">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <!--  <button type="button" class="layui-btn layui-btn-sm " v-if="select_img != ''" style="margin-left:30px;" @click="removeImg('select_img')">清除封面</button>-->
                <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：高度1：1宽度 </p>
              </el-form-item>
              <el-form-item label="栏目状态" prop="status">
                <el-radio-group v-model="videoboxdata.status">
                  <el-radio label="1">正常</el-radio>
                  <el-radio label="0">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否隐藏标题" prop="isTitleHide">
                <el-radio-group v-model="videoboxdata.isTitleHide">
                  <el-radio label="1">显示</el-radio>
                  <el-radio label="0">隐藏</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="展示方式" prop="is_public">
                <el-radio-group v-model="videoboxdata.is_public">
                  <el-radio label="0">图文</el-radio>
                  <el-radio label="1">列表</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="视频列表" prop="file_ids">
                <el-checkbox-group v-model="videoboxdata.file_ids">
                  <el-table :data="videoList.filter(data => !videosearch || data.title.toLowerCase().includes(videosearch.toLowerCase()))" border style="width: 100%" height="350">
                    <el-table-column width="80" label="序号">
                      <template slot-scope="scope">
                        <el-checkbox :label="scope.row.id">{{scope.$index+1}}</el-checkbox>
                      </template>
                    </el-table-column>
                    <el-table-column prop="id" width="80" align="center" label="ID">
                    </el-table-column>
                    <el-table-column prop="title" label="名称">
                      <template slot="header" slot-scope="scope">
                          <el-input v-model="videosearch" size="mini" placeholder="输入名称搜索" />
                      </template>
                    </el-table-column>
                  </el-table>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item style="text-align:center;">
                <button type="button" class="layui-btn" style="margin-left:-65px;" @click="savevideobox">保存</button>
              </el-form-item>
            </el-form>
          </div>
        </el-dialog>

      <!--关联图片-->
      <el-dialog title="编辑照片" :visible.sync="imageboxDialog" :modal-append-to-body="false" :close-on-click-modal="false" width="850px">
        <div class="lanmu_box">
          <el-form :model="imageboxdata" label-width="120px" :rules="imageboxrules" ref="imageboxdata">
            <el-form-item label="栏目类型" prop="type">
              <el-select v-model="imageboxdata.type" placeholder="请选择栏目类型" disabled>
                <template v-for="(items,index) in lanmuTyleList">
                  <el-option v-if="items.status" :label="items.name" :value="items.id"></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="栏目名称" prop="title">
              <el-input v-model="imageboxdata.title"></el-input>
            </el-form-item>
            <el-form-item label="栏目图(未选中)" prop="no_select_img">
              <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile4" auto-upload list-type="picture-card" style="overflow:hidden;">
                <img :src="no_select_img" style="width:100%;height:100%;" v-if="no_select_img != ''">
                <i class="el-icon-plus"></i>
              </el-upload>
              <!--<button type="button" class="layui-btn layui-btn-sm " v-if="no_select_img != ''" style="margin-left:30px;" @click="removeImg('no_select_img')">清除封面</button>-->
              <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：高度1：1宽度 </p>
            </el-form-item>
            <el-form-item label="栏目图(选中)" prop="select_img">
              <el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="getFile3" auto-upload list-type="picture-card" style="overflow:hidden;">
                <img :src="select_img" style="width:100%;height:100%;" v-if="select_img != ''">
                <i class="el-icon-plus"></i>
              </el-upload>
              <!--  <button type="button" class="layui-btn layui-btn-sm " v-if="select_img != ''" style="margin-left:30px;" @click="removeImg('select_img')">清除封面</button>-->
              <p style="font-size:12px;margin-top:7px;color:#606266">建议尺寸：高度1：1宽度 </p>
            </el-form-item>
            <el-form-item label="栏目状态" prop="status">
              <el-radio-group v-model="imageboxdata.status">
                <el-radio label="1">正常</el-radio>
                <el-radio label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否隐藏标题" prop="isTitleHide">
              <el-radio-group v-model="imageboxdata.isTitleHide">
                <el-radio label="1">显示</el-radio>
                <el-radio label="0">隐藏</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="照片类型" prop="is_full">
              <el-radio-group v-model="imageboxdata.is_full">
                <el-radio label="1">引用相册</el-radio>
                <!--<el-radio label="1">手动添加照片</el-radio>-->
              </el-radio-group>
            </el-form-item>
            <el-form-item label="相册列表" prop="file_ids">
              <el-checkbox-group v-model="imageboxdata.file_ids">
                <el-table :data="imageList.filter(data => !imagesearch || data.title.toLowerCase().includes(imagesearch.toLowerCase()))" border style="width: 100%" height="350">
                  <el-table-column width="80" label="序号">
                    <template slot-scope="scope">
                      <el-checkbox :label="scope.row.id">{{scope.$index+1}}</el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column prop="id" width="80" align="center" label="ID">
                  </el-table-column>
                  <el-table-column prop="title" label="名称">
                    <template slot="header" slot-scope="scope">
                      <el-input v-model="imagesearch" size="mini" placeholder="输入名称搜索" />
                    </template>
                  </el-table-column>
                </el-table>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item style="text-align:center;">
              <button type="button" class="layui-btn" style="margin-left:-65px;" @click="saveimagebox">保存</button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>

      </div>
    </template>

<script>
  import VueUeditorWrap from "vue-ueditor-wrap";
  export default {
    name: "zhuantilan",
    props:{
      zhuantibox:{
            type:Object
         }
    },
    data() {
      return {
        lanmuData: [], //栏目列表
        lanmuloading:false,//栏目loading
        lanmuTyleList:[
          {
            name:'内容单页',
            id:1,
            status:false,
          },
          {
            name:'内容列表',
            id:2,
            status:false,
          },
          {
            name:'跳转链接',
            id:3,
            status:false,
          },
          {
            name:'附件下载',
            id:4,
            status:false,
          },
          {
            name:'关联嘉宾',
            id:5,
            status:true,
          },
          {
            name:'会议详情',
            id:6,
            status:false,
          },
          {
            name:'我的报名',
            id:7,
            status:false,
          },
          {
            name:'发票开票',
            id:8,
            status:false,
          },
          {
            name:'会后-媒体报道',
            id:9,
            status:false,
          },
          {
            name:'会后-会议资料',
            id:10,
            status:false,
          },
          {
            name:'会后-会议回顾',
            id:11,
            status:false,
          },
          {
            name:'查找座位',
            id:12,
            status:false,
          },
          {
            name:'顶级栏目',
            id:13,
            status:false,
          },
          {
            name:'图文直播',
            id:14,
            status:false,
          },
          {
            name:'顶级栏目',
            id:15,
            status:true,
          },
          {
            name:'视频列表',
            id:18,
            status:true,
          },
          {
            name:'合作机构',
            id:20,
            status:true,
          },
          {
            name:'资讯',
            id:21,
            status:true,
          },
          {
            name:'直播',
            id:22,
            status:true,
          },
          {
            name:'议程',
            id:23,
            status:true,
          },
          {
            name:'照片',
            id:24,
            status:true,
          },
        ],//栏目类型列表
        //新增栏目
        lanmuDialog:false,
        lanmubox:{
          pid:'',
          name:'',//名称
          type:'',//类型
          status:'1',//状态
        },//新增修改栏目信息
        lmrules: {
          name: [
            { required: true, message: '请填写会议名称', trigger: 'blur' },
          ],
          type: [
            { required: true, message: '请选择栏目类型', trigger: 'change' }
          ],
          status: [
            { required: true, message: '请选择栏目状态', trigger: 'change' }
          ],
        },
        //富文本配置
        myConfig: {
          // 编辑器不自动被内容撑高
          autoHeightEnabled: false,
          // 初始容器高度
          initialFrameHeight: 240,
          // 初始容器宽度
          initialFrameWidth: '100%',
          retainOnlyLabelPasted: false,
          pasteplain: false,
          toolbars: [[
            'source', '|', 'undo', 'redo',  '|',
            'bold', 'italic', 'underline', 'strikethrough', 'forecolor', 'backcolor', 'superscript', 'subscript',  'autotypeset', 'blockquote', 'pasteplain', '|','removeformat', 'formatmatch','cleardoc','|',
            'paragraph', 'fontfamily', 'fontsize', '|',
            'insertorderedlist', 'insertunorderedlist', 'rowspacingtop', 'rowspacingbottom', 'lineheight','indent', '|',
            'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'touppercase', 'tolowercase', '|',
            'link', 'unlink', /*'anchor',*/ '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|', 'insertimage', 'emotion', /*'insertvideo', 'music', 'attachment',*//* 'map',*/ 'insertframe', 'background', '|',
            'horizontal',  'spechars', '|',
            'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow', 'deleterow', /*'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', */'|',
            /*'print',*/'selectall','135editor','searchreplace'
          ]],
          zIndex: 200000,
          // 上传文件接口
          serverUrl: "/ac1/conference/uploadBase64",
          UEDITOR_HOME_URL: './static/UEditor/'
        },
        videoList:[],//视频列表
        //修改顶级栏目
        changeDjDialog:false,//修改顶级栏目
        djdata:{},//顶级栏目box

        //通用图片
        select_img:'',//选中状态图
        no_select_img:'',//未选中图片


        //直播栏目编辑
        changezhiboDialog:false,
        zhibodata:{},//直播box
        zhiborules: {
          title: [
            { required: true, message: '请填写栏目名称', trigger: 'blur' },
          ],
          type: [
            { required: true, message: '请选择栏目类型', trigger: 'change' }
          ],
          status: [
            { required: true, message: '请选择栏目状态', trigger: 'change' }
          ],
          isTitleHide: [
            { required: true, message: '请选择标题状态', trigger: 'change' }
          ],
          is_full: [
            { required: true, message: '请选择直播状态', trigger: 'change' }
          ],
          jump_url: [
            { required: true, message: '请填写跳转地址', trigger: 'blur' },
          ],
          file_url: [
            { required: true, message: '请填写跳第三方视频链接', trigger: 'blur' },
          ],
          content: [
            { required: true, message: '请填写iframe地址', trigger: 'blur' },
          ],
          video_id: [
            { required: true, message: '请选择视频', trigger: 'change' }
          ],
        },

        //议程栏目编辑
        yichengDialog:false,
        yichengdata:{},//议程编辑box
        yichengrules: {
          title: [
            { required: true, message: '请填写栏目名称', trigger: 'blur' },
          ],
          type: [
            { required: true, message: '请选择栏目类型', trigger: 'change' }
          ],
          status: [
            { required: true, message: '请选择栏目状态', trigger: 'change' }
          ],
          isTitleHide: [
            { required: true, message: '请选择标题状态', trigger: 'change' }
          ],
          agenda_status: [
            { required: true, message: '请选择议程状态', trigger: 'change' }
          ],
          content: [
            { required: true, message: '请填写内容', trigger: 'blur' },
          ],
          desc: [
            { required: true, message: '请添加内容', trigger: 'blur' },
          ],
        },
        yichengaddDialog:false,
        yichengaddIndex:'',//编辑位置
        yichengadd:{
          type:'1',//类型
          times:'',//时间
          info:'',//详情
        },//新增列表
        yichengaddrules:{
          times: [
            { required: true, message: '请填写时间', trigger: 'blur' },
          ],
          type: [
            { required: true, message: '请选择栏目类型', trigger: 'change' }
          ],
          info: [
            { required: true, message: '请填写内容', trigger: 'blur' },
          ],
        },
        //值 合作机构
        zhiboxDialog:false,
        zhiboxdata:{},//议程编辑box
        zhiboxrules: {
          title: [
            { required: true, message: '请填写栏目名称', trigger: 'blur' },
          ],
          type: [
            { required: true, message: '请选择栏目类型', trigger: 'change' }
          ],
          status: [
            { required: true, message: '请选择栏目状态', trigger: 'change' }
          ],
          isTitleHide: [
            { required: true, message: '请选择标题状态', trigger: 'change' }
          ],
          desc: [
            { required: true, message: '请添加列表内容', trigger: 'blur' },
          ],
        },
        zhiboxaddDialog:false,
        zhiboxaddIndex:'',//编辑位置
        zhiboxadd:{
          name:'',//名称
          link:'',//链接
        },//新增列表
        zhiboxaddrules:{
          name: [
            { required: true, message: '请填写名称', trigger: 'blur' },
          ],
        },

        //关联嘉宾
        jiabinboxDialog:false,
        jiabinboxdata:{},//关联嘉宾box
        jiabinboxrules: {
          title: [
            { required: true, message: '请填写栏目名称', trigger: 'blur' },
          ],
          type: [
            { required: true, message: '请选择栏目类型', trigger: 'change' }
          ],
          status: [
            { required: true, message: '请选择栏目状态', trigger: 'change' }
          ],
          isTitleHide: [
            { required: true, message: '请选择标题状态', trigger: 'change' }
          ],
          guest_ids: [
            { required: true, message: '请选择嘉宾', trigger: 'change' }
          ],
        },
        jiabinlistbox:[],//嘉宾列表
        jiabinPaixu:[],//嘉宾排序列表
        search:'',//搜索嘉宾

        //关联资讯
        zixunboxDialog:false,
        zixunboxdata:{},//关联资讯
        zixunboxrules: {
          title: [
            { required: true, message: '请填写栏目名称', trigger: 'blur' },
          ],
          type: [
            { required: true, message: '请选择栏目类型', trigger: 'change' }
          ],
          status: [
            { required: true, message: '请选择栏目状态', trigger: 'change' }
          ],
          isTitleHide: [
            { required: true, message: '请选择标题状态', trigger: 'change' }
          ],
          is_public: [
            { required: true, message: '请选择展示方式', trigger: 'change' }
          ],
          file_ids: [
            { required: true, message: '请选择资讯', trigger: 'change' }
          ],
        },
        zixunlistbox:[],//资讯列表
        zxsearch:'',//搜索资讯

        //关联视频
        videoboxDialog:false,
        videoboxdata:{},//关联视频box
        videoboxrules: {
          title: [
            { required: true, message: '请填写栏目名称', trigger: 'blur' },
          ],
          type: [
            { required: true, message: '请选择栏目类型', trigger: 'change' }
          ],
          status: [
            { required: true, message: '请选择栏目状态', trigger: 'change' }
          ],
          isTitleHide: [
            { required: true, message: '请选择标题状态', trigger: 'change' }
          ],
          is_public: [
            { required: true, message: '请选择展示方式', trigger: 'change' }
          ],
          file_ids: [
            { required: true, message: '请选择视频', trigger: 'change' }
          ],
        },
        videosearch:'',//搜索视频

        //关联图片
        imageList:[],
        imageboxDialog:false,
        imageboxdata:{},//关联图片box
        imageboxrules: {
          title: [
            { required: true, message: '请填写栏目名称', trigger: 'blur' },
          ],
          type: [
            { required: true, message: '请选择栏目类型', trigger: 'change' }
          ],
          status: [
            { required: true, message: '请选择栏目状态', trigger: 'change' }
          ],
          isTitleHide: [
            { required: true, message: '请选择标题状态', trigger: 'change' }
          ],
          is_full: [
            { required: true, message: '请选择照片类型', trigger: 'change' }
          ],
          file_ids: [
            { required: true, message: '请选择相册', trigger: 'change' }
          ],
        },
        imagesearch:'',//搜索图片
      };
    },
    components: {
      VueUeditorWrap,
    },
    filters: {
      ellipsis(value) {
        if (!value) return "";
        if (value.length > 30) {
          return value.slice(0, 30) + "...";
        }
        return value;
      }
    },
    created() {
      var _this = this;
    },
    mounted: function () {
      this.$nextTick(function () {
        this.getlanmulist();
      })
    },
    methods: {
      /*上传图片*/
      getBase64(file){  //把图片转成base64编码
        return new Promise(function(resolve,reject){
          let reader=new FileReader();
          let imgResult="";
          reader.readAsDataURL(file);
          reader.onload=function(){
            imgResult=reader.result;
          };
          reader.onerror=function(error){
            reject(error);
          };
          reader.onloadend=function(){
            resolve(imgResult);
          }
        })
      },
      uploadImg(option,type){
        var _this = this;
        var file = option.file;
        this.getBase64(file).then(res=>{
          // 读取到的图片base64 数据编码 将此编码字符串传给后台即可
          let params = { base64:res};
          let url = _this.APIurl.API.api.up_baimg;
          _this
            .$postform(url, params)
            .then((res) => {
            if (parseInt(res.code) === 1)
            {
              _this.$message({
                message: "上传成功",
                type: "success",
                duration: 1000,
              });
              if(type == 'video_cover_url'){
                _this.zhibodata.video_cover_url =  res.posts[0].domain+'/'+res.posts[0].image;
              }
              if(type == 'author'){
                _this.zhibodata.author =  res.posts[0].domain+'/'+res.posts[0].image;
              }
              if(type == 'select_img'){
                _this.select_img =  res.posts[0].domain+'/'+res.posts[0].image;
              }
              if(type == 'no_select_img'){
                _this.no_select_img =  res.posts[0].domain+'/'+res.posts[0].image;
              }
            } else
            {
              _this.$message({
                message: res.msg,
                type: "warning",
                duration: 1000,
              });
            }
          }).catch((error) => {
            if (error == undefined)
            {
              layer.msg("仅支持上传图片");
            } else
            {
              _this.$message({
                message: error,
                type: "error",
                duration: 1000,
              });
            }
          });
        })
      },
      //直播待开始封面
      getFile(option){  //上传
        var _this = this;
        _this.uploadImg(option,'video_cover_url');
      },
      //直播中封面
      getFile2(option){  //上传
        var _this = this;
        _this.uploadImg(option,'author');
      },
      getFile3(option){  //上传
        var _this = this;
        _this.uploadImg(option,'select_img');
      },
      getFile4(option){  //上传
        var _this = this;
        _this.uploadImg(option,'no_select_img');
      },
      //清除背景图
      removeImg(type){
        var _this = this;
        if(type == 'video_cover_url'){
          _this.zhibodata.video_cover_url = '';
        }
        if(type == 'author'){
          _this.zhibodata.author = '';
        }
        if(type == 'logo'){
          _this.zhuantibox.logo = '';
        }
        if(type == 'select_img'){
          _this.select_img = '';
        }
        if(type == 'no_select_img'){
          _this.no_select_img = '';
        }

      },
      //新增顶级栏目
      addNewToplan(){
        var _this= this;
        _this.lanmubox.pid='';
        _this.select_img = '';//选中状态图
        _this.no_select_img = '';//未选中图片
        _this.lanmuDialog = true;
      },
      //新增子栏目
      addZilanmu(pid){
        var _this= this;
        _this.lanmubox.pid = pid;
        _this.select_img = '';//选中状态图
        _this.no_select_img = '';//未选中图片
        _this.lanmuDialog = true;
      },
      //获取会议栏目
      getlanmulist(){
          var _this = this;
          _this.lanmuloading = true;
          var url = "/ac1/conference/column/conferenceList";
          var params = {
            conferenceId:_this.zhuantibox.conferenceId,
            id:_this.zhuantibox.conferenceId,
            type:1
          }
          _this.$get(url, params).then(res => {
            if (res.code == 1)
            {
              _this.lanmuData = res.posts;
              _this.lanmuloading = false;
            }
          })
      },
      //新增编辑栏目
      addlanmupost(){
        var _this = this;
        this.$refs['lanmubox'].validate((valid) => {
          if (valid) {
            var url = "/ac1/conference/column/save";
            var params = {
              conference_id:_this.zhuantibox.conferenceId,
              title:_this.lanmubox.name,
              type:_this.lanmubox.type,
              status:_this.lanmubox.status,
              pid:_this.lanmubox.pid,
              select_img:_this.select_img,//选中状态图
              no_select_img:_this.no_select_img,//未选中图片
              isTitleHide:1,
              is_full:'1',
              is_public:'1',
              isSharePage:1,
              isNewPage:1,
            }
            _this.$post(url, params).then(res => {
              if (res.code == 1)
              {
                _this.$message({
                  message: '添加成功',
                  type: 'success',
                  duration: 1000
                });
                _this.lanmuDialog = false;
                _this.lanmubox ={
                  pid:'',
                  name:'',//名称
                  type:'',//类型
                  status:'1',//状态
                };
                 _this.select_img = '';//选中状态图
                 _this.no_select_img = '';//未选中图片
                _this.getlanmulist();
              }
            })

          } else {
            _this.$message({
              message: '请正确填写栏目信息!',
              type: "error",
              duration: 1000,
            });
            return false;
          }
        });
      },
      //编辑栏目
      handleEdit(datas){
        var _this = this;
        _this.lanmuloading = true;
     /*   if(datas.type == 15){
          _this.changeDjDialog = true;
          _this.djdata = datas;
          _this.djdata.status = String(_this.djdata.status);
          _this.lanmuloading = false;
        }else{
          _this.getlanmuInfo(datas.id,datas.type);
        }*/
        _this.getlanmuInfo(datas.id,datas.type);

      },
      //栏目排序
      reachLanmu(){
        var _this = this;
        var url = "/ac1/conference/column/sort";
        var params = [];
        var lists = JSON.parse(JSON.stringify(_this.lanmuData))
        for(var i=0;i<lists.length;i++){
          params.push({
            id:lists[i].id,
            listOrder:lists[i].list_order,
          });
          if(lists[i].list != undefined && lists[i].list.length > 0){
            for(var j=0;j<lists[i].list.length;j++){
              params.push({
                id:lists[i].list[j].id,
                listOrder:lists[i].list[j].list_order,
              });
            }
          }
        }
        _this.$post(url, params).then(res => {
          if (res.code == 1)
          {
            _this.$message({
              message: '更新排序成功',
              type: 'success',
              duration: 1000
            });
            _this.getlanmulist();
          }
        })
      },
      //删除栏目
      handleDelete(id){
        var _this = this;
        this.$confirm('确定删除此栏目吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //向服务端发送删除指令
          let url = _this.APIurl.API.api.lan_del;
          let params = { id: id };
          _this.$delet(url, params)
            .then((res) => {
            if (parseInt(res.code) === 1)
            {
              _this.$message({
                message: "删除成功",
                type: "success",
                duration: 1000,
              });
              _this.getlanmulist();
            } else
            {
              if (res.msg == "参数错误：！")
              {
                this.$message.error('删除错误!');
                return false;
              } else if (res.msg == "不支持删除此状态的会议")
              {
                this.$message.error('不支持删除此状态的会议!');
                return false;
              } else
              {
                this.$message.error('无法删除！');
                return false;
              }
            }
          }).catch((error) => {
            console.log(error);
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },

      //获取视频列表
      getVideoList(){
        var _this = this;
        let url = '/ac1/conferece/video/list';
        let params = {
          conferenceId:_this.zhuantibox.conferenceId,
          title:'',
        };
        _this.$get(url, params)
          .then((res) => {
          if (parseInt(res.code) === 1)
          {
            _this.videoList = res.posts;
          } else
          {
             console.log(res.msg);
          }
        }).catch((error) => {
          console.log(error);
        });
      },
      //获取栏目详情
      getlanmuInfo(id,type){
        var _this = this;
        _this.lanmuloading = true;
        let url = '/ac1/conference/column/detail';
        let params = {
          id:id,
          type:type,
        };
        _this.$get(url, params)
          .then((res) => {
          if (parseInt(res.code) === 1)
          {
            var newbox = res.posts;
            newbox.video_id = Number(newbox.video_id);
            newbox.status = String(newbox.status);
            newbox.is_full = String(newbox.is_full);
            newbox.isTitleHide = String(newbox.isTitleHide);
            newbox.is_public = String(newbox.is_public);
            newbox.agenda_status = String(newbox.agenda_status);

            _this.select_img = newbox.select_img;//选中状态图
            _this.no_select_img = newbox.no_select_img;//未选中图片
            if(type == 15){
              _this.changeDjDialog = true;
              _this.djdata = newbox;
              _this.lanmuloading = false;
            }
            if(type == 22){
              _this.getVideoList();
              _this.zhibodata = newbox;
              _this.lanmuloading = false;
              _this.changezhiboDialog = true;
            }
            if(type == 23){
              _this.yichengdata = newbox;
              if(_this.yichengdata.desc != ''){
                _this.yichengdata.desc = JSON.parse(_this.yichengdata.desc);
              }else{
                _this.yichengdata.desc = [];
              }
              _this.lanmuloading = false;
              _this.yichengDialog = true;
            }
            if(type == 20){
              _this.zhiboxdata = newbox;
              if(_this.zhiboxdata.desc != ''){
                _this.zhiboxdata.desc = JSON.parse(_this.zhiboxdata.desc);
              }else{
                _this.zhiboxdata.desc = [];
              }
              _this.lanmuloading = false;
              _this.zhiboxDialog = true;
            }
            if(type == 5){
              _this.jiabinboxdata = newbox;
              if(_this.jiabinboxdata.guest_ids != 'null'){
                var numbox = JSON.parse(_this.jiabinboxdata.guest_ids);
                _this.jiabinboxdata.guest_ids = numbox.map(Number);
              }else{
                _this.jiabinboxdata.guest_ids = [];
              }
              _this.getJiabinlist();
              _this.lanmuloading = false;
              _this.jiabinboxDialog = true;
            }
            if(type == 21){
              _this.zixunboxdata = newbox;
              if(_this.zixunboxdata.file_ids != 'null'){
                var numbox = JSON.parse(_this.zixunboxdata.file_ids);
                _this.zixunboxdata.file_ids = numbox.map(Number);
              }else{
                _this.zixunboxdata.file_ids = [];
              }
              _this.getzixunlist();
              _this.lanmuloading = false;
              _this.zixunboxDialog = true;
            }
            if(type == 18){
              _this.videoboxdata = newbox;
              if(_this.videoboxdata.file_ids != 'null'){
                var numbox = JSON.parse(_this.videoboxdata.file_ids);
                _this.videoboxdata.file_ids = numbox.map(Number);
              }else{
                _this.videoboxdata.file_ids = [];
              }
              _this.getVideoList();
              _this.lanmuloading = false;
              _this.videoboxDialog = true;
            }

            if(type == 24){
              _this.imageboxdata = newbox;
              if(_this.imageboxdata.file_ids != 'null'){
                var numbox = JSON.parse(_this.imageboxdata.file_ids);
                _this.imageboxdata.file_ids = numbox.map(Number);
              }else{
                _this.imageboxdata.file_ids = [];
              }
              _this.getImageList();
              _this.lanmuloading = false;
              _this.imageboxDialog = true;
            }

          } else{
            console.log(res.msg);
          }
        }).catch((error) => {
          console.log(error);
        });
      },
      //修改顶级栏目
      changeDJ(){
        var _this = this;
        var url = "/ac1/conference/column/save";
        var params = {
          conference_id:_this.djdata.conference_id,
          id:_this.djdata.id,
          title:_this.djdata.title,
          type:_this.djdata.type,
          status:_this.djdata.status,
          pid:_this.djdata.pid,
          list_order:_this.djdata.list_order,
          select_img:_this.select_img,//选中状态图
          no_select_img:_this.no_select_img,//未选中图片
          isNewPage:1,
        }
        _this.$post(url, params).then(res => {
          if (res.code == 1)
          {
            _this.$message({
              message: '修改成功',
              type: 'success',
              duration: 1000
            });
            _this.changeDjDialog = false;
            _this.select_img = '';//选中状态图
            _this.no_select_img = '';//未选中图片
            _this.getlanmulist();
          }
        })
      },


      //保存直播栏目
      saveZhibo(){
        var _this = this;
        this.$refs['zhibodata'].validate((valid) => {
          if (valid) {
            var url = "/ac1/conference/column/save";
            var params = {
              conference_id:_this.zhibodata.conference_id,
              id:_this.zhibodata.id,
              type:_this.zhibodata.type,
              status:_this.zhibodata.status,
              list_order:_this.zhibodata.list_order,
              content:_this.zhibodata.content,
              jump_url:_this.zhibodata.jump_url,
              file_url:_this.zhibodata.file_url,
              title:_this.zhibodata.title,
              video_cover_url:_this.zhibodata.video_cover_url,
              is_public:_this.zhibodata.is_public,
              video_id:_this.zhibodata.video_id,
              author:_this.zhibodata.author,
              is_full:_this.zhibodata.is_full,
              isTitleHide:_this.zhibodata.isTitleHide,
              pid:_this.zhibodata.pid,
              select_img:_this.select_img,//选中状态图
              no_select_img:_this.no_select_img,//未选中图片
              isNewPage:1,
              isSharePage:1,
            }
            _this.$post(url, params).then(res => {
              if (res.code == 1)
              {
                _this.$message({
                  message: '保存成功',
                  type: 'success',
                  duration: 1000
                });
                _this.changezhiboDialog = false;
                _this.select_img = '';//选中状态图
                _this.no_select_img = '';//未选中图片
                _this.getlanmulist();
              }
            })

          } else {
            _this.$message({
              message: '请正确填写栏目信息!',
              type: "error",
              duration: 1000,
            });
            return false;
          }
        });
      },

      //新增议程列表内容
      yichengAddshow(){
        var _this = this;
        _this.yichengaddIndex = '';
        _this.yichengadd = {
          type:"1",
          times:'',
          info:'',
        }
        _this.yichengaddDialog = true;
      },
      yichengAddSave() {
        var _this = this;
        this.$refs['yichengadd'].validate((valid) => {
          if (valid) {
            if(_this.yichengaddIndex !== ''){
              _this.$set(_this.yichengdata.desc,_this.yichengaddIndex,_this.yichengadd);
            }else{
              _this.yichengdata.desc.push(_this.yichengadd)
            }
            _this.yichengaddDialog = false;
            _this.yichengaddIndex = '';
            _this.yichengadd = {
              type:"1",
              times:'',
              info:'',
            }
          } else {
            _this.$message({
              message: '请正确填写表单内容!',
              type: "error",
              duration: 1000,
            });
            return false;
          }
        });
      },
      //修改议程列表内容
      changeYCadd(index){
        var _this = this;
        _this.yichengadd =JSON.parse(JSON.stringify(_this.yichengdata.desc[index]));
        _this.yichengaddIndex = index;
        _this.yichengaddDialog = true;
      },
      removeYCadd(index){
        var _this = this;
        _this.yichengdata.desc.splice(index,1);
      },
      //保存议程栏目
      saveYicheng(){
        var _this = this;
        this.$refs['yichengdata'].validate((valid) => {
          if (valid) {
            var url = "/ac1/conference/column/save";
            var params = {
              conference_id:_this.yichengdata.conference_id,
              id:_this.yichengdata.id,
              type:_this.yichengdata.type,
              agenda_status:_this.yichengdata.agenda_status,
              status:_this.yichengdata.status,
              list_order:_this.yichengdata.list_order,
              content:_this.yichengdata.content,
              title:_this.yichengdata.title,
              is_public:_this.yichengdata.is_public,
              desc:JSON.stringify(_this.yichengdata.desc),
              isTitleHide:_this.yichengdata.isTitleHide,
              pid:_this.yichengdata.pid,
              select_img:_this.select_img,//选中状态图
              no_select_img:_this.no_select_img,//未选中图片
              isNewPage:1,
              isSharePage:1,
            }
            _this.$post(url, params).then(res => {
              if (res.code == 1)
              {
                _this.$message({
                  message: '保存成功',
                  type: 'success',
                  duration: 1000
                });
                _this.yichengDialog = false;
                _this.select_img = '';//选中状态图
                _this.no_select_img = '';//未选中图片
                _this.getlanmulist();
              }
            })

          } else {
            _this.$message({
              message: '请正确填写栏目信息!',
              type: "error",
              duration: 1000,
            });
            return false;
          }
        });
      },

      //值 合作机构
      zhiboxAddShow(){
        var _this = this;
        _this.zhiboxaddIndex = '';
        _this.zhiboxadd = {
          name:'',
          link:'',
        }
        _this.zhiboxaddDialog = true;
      },
      zhiboxAddsave() {
        var _this = this;
        this.$refs['zhiboxadd'].validate((valid) => {
          if (valid) {
            if(_this.zhiboxaddIndex !== ''){
              _this.$set(_this.zhiboxdata.desc,_this.zhiboxaddIndex,_this.zhiboxadd);
            }else{
              _this.zhiboxdata.desc.push(_this.zhiboxadd)
            }
            _this.zhiboxaddDialog = false;
            _this.zhiboxaddIndex = '';
            _this.zhiboxadd = {
              name:'',
              link:'',
            }
          } else {
            _this.$message({
              message: '请正确填写表单内容!',
              type: "error",
              duration: 1000,
            });
            return false;
          }
        });
      },
      //修改议程列表内容
      changezhibox(index){
        var _this = this;
        _this.zhiboxadd =JSON.parse(JSON.stringify(_this.zhiboxdata.desc[index]));
        _this.zhiboxaddIndex = index;
        _this.zhiboxaddDialog = true;
      },
      removezhibox(index){
        var _this = this;
        _this.zhiboxdata.desc.splice(index,1);
      },
      //保存合作机构栏目
      savezhibox(){
        var _this = this;
        this.$refs['zhiboxdata'].validate((valid) => {
          if (valid) {
            var url = "/ac1/conference/column/save";
            var params = {
              conference_id:_this.zhiboxdata.conference_id,
              id:_this.zhiboxdata.id,
              type:_this.zhiboxdata.type,
              status:_this.zhiboxdata.status,
              list_order:_this.zhiboxdata.list_order,
              title:_this.zhiboxdata.title,
              desc:JSON.stringify(_this.zhiboxdata.desc),
              pid:_this.zhiboxdata.pid,
              isTitleHide:_this.zhiboxdata.isTitleHide,
              select_img:_this.select_img,//选中状态图
              no_select_img:_this.no_select_img,//未选中图片
              isNewPage:1,
              isSharePage:1,
            }
            _this.$post(url, params).then(res => {
              if (res.code == 1)
              {
                _this.$message({
                  message: '保存成功',
                  type: 'success',
                  duration: 1000
                });
                _this.zhiboxDialog = false;
                _this.select_img = '';//选中状态图
                _this.no_select_img = '';//未选中图片
                _this.getlanmulist();
              }
            })

          } else {
            _this.$message({
              message: '请正确填写栏目信息!',
              type: "error",
              duration: 1000,
            });
            return false;
          }
        });
      },

      //获取嘉宾
      getJiabinlist(){
        var _this = this;
        let url = _this.APIurl.API.api.guest_list;
        let params = {};
        _this.$get(url, params)
          .then((res) => {
          if (parseInt(res.code) === 1)
          {
            _this.jiabinlistbox = res.posts.data;
            for(var i =0;i<res.posts.data.length;i++){
              if(_this.jiabinboxdata.guest_ids.indexOf(res.posts.data[i].id) != -1){
                _this.jiabinPaixu.push(_this.jiabinboxdata.guest_ids.indexOf(res.posts.data[i].id)+1)
              }else{
                _this.jiabinPaixu.push(0);
              }
            }
          } else
          {
            console.log(res.msg);
          }
        }).catch((error) => {
          console.log(error);
        });
      },
      sortBy(i) {
        return function(a,b) {
          return a[i] - b[i] //  a[i] - b[i]为正序，倒叙为  b[i] - a[i]
        }
      },
      //保存嘉宾栏目
      savejiabinbox(){
        var _this = this;
        this.$refs['jiabinboxdata'].validate((valid) => {
          if (valid) {
            var url = "/ac1/conference/column/save";
            var lists = [];
            for(var i=0;i<_this.jiabinlistbox.length;i++){
              if(_this.jiabinboxdata.guest_ids.indexOf(_this.jiabinlistbox[i].id) != -1){
                lists.push({
                  id:_this.jiabinlistbox[i].id,
                  index:_this.jiabinPaixu[i],
                });
              }
            }
            var listbox =  lists.sort(_this.sortBy("index"));
            var guest_ids =[];
            for(var j=0;j<listbox.length;j++){
              guest_ids.push(listbox[j].id);
            }
            var params = {
              conference_id:_this.jiabinboxdata.conference_id,
              id:_this.jiabinboxdata.id,
              type:_this.jiabinboxdata.type,
              status:_this.jiabinboxdata.status,
              list_order:_this.jiabinboxdata.list_order,
              title:_this.jiabinboxdata.title,
              guest_ids:guest_ids,
              pid:_this.jiabinboxdata.pid,
              isTitleHide:_this.jiabinboxdata.isTitleHide,
              select_img:_this.select_img,//选中状态图
              no_select_img:_this.no_select_img,//未选中图片
              isNewPage:1,
              isSharePage:1,
            }
            _this.$post(url, params).then(res => {
              if (res.code == 1)
              {
                _this.$message({
                  message: '保存成功',
                  type: 'success',
                  duration: 1000
                });
                _this.jiabinboxDialog = false;
                _this.select_img = '';//选中状态图
                _this.no_select_img = '';//未选中图片
                _this.getlanmulist();
              }
            })

          } else {
            _this.$message({
              message: '请正确填写栏目信息!',
              type: "error",
              duration: 1000,
            });
            return false;
          }
        });
      },

      //获取资讯
      getzixunlist(){
        var _this = this;
        let url = _this.APIurl.API.api.zixinlists;
        let params = {
          id:_this.zixunboxdata.conference_id,
          page:0,
          pagesize:0,
          filter:0,
        };
        _this.$get(url, params)
          .then((res) => {
          if (parseInt(res.code) === 1)
          {
            _this.zixunlistbox = res.posts.list;
          } else
          {
            console.log(res.msg);
          }
        }).catch((error) => {
          console.log(error);
        });
      },
      //保存资讯栏目
      savezixunbox(){
        var _this = this;
        this.$refs['zixunboxdata'].validate((valid) => {
          if (valid) {
            var url = "/ac1/conference/column/save";
            var params = {
              conference_id:_this.zixunboxdata.conference_id,
              id:_this.zixunboxdata.id,
              type:_this.zixunboxdata.type,
              status:_this.zixunboxdata.status,
              list_order:_this.zixunboxdata.list_order,
              title:_this.zixunboxdata.title,
              is_public:_this.zixunboxdata.is_public,
              file_ids:_this.zixunboxdata.file_ids,
              pid:_this.zixunboxdata.pid,
              isTitleHide:_this.zixunboxdata.isTitleHide,
              select_img:_this.select_img,//选中状态图
              no_select_img:_this.no_select_img,//未选中图片
              isNewPage:1,
              isSharePage:1,
            }
            _this.$post(url, params).then(res => {
              if (res.code == 1)
              {
                _this.$message({
                  message: '保存成功',
                  type: 'success',
                  duration: 1000
                });
                _this.zixunboxDialog = false;
                _this.select_img = '';//选中状态图
                _this.no_select_img = '';//未选中图片
                _this.getlanmulist();
              }
            })

          } else {
            _this.$message({
              message: '请正确填写栏目信息!',
              type: "error",
              duration: 1000,
            });
            return false;
          }
        });
      },


      //保存视频栏目
      savevideobox(){
        var _this = this;
        this.$refs['videoboxdata'].validate((valid) => {
          if (valid) {
            var url = "/ac1/conference/column/save";
            var params = {
              conference_id:_this.videoboxdata.conference_id,
              id:_this.videoboxdata.id,
              type:_this.videoboxdata.type,
              status:_this.videoboxdata.status,
              list_order:_this.videoboxdata.list_order,
              title:_this.videoboxdata.title,
              is_public:_this.videoboxdata.is_public,
              file_ids:_this.videoboxdata.file_ids,
              pid:_this.videoboxdata.pid,
              isTitleHide:_this.videoboxdata.isTitleHide,
              select_img:_this.select_img,//选中状态图
              no_select_img:_this.no_select_img,//未选中图片
              isNewPage:1,
              isSharePage:1,
            }
            _this.$post(url, params).then(res => {
              if (res.code == 1)
              {
                _this.$message({
                  message: '保存成功',
                  type: 'success',
                  duration: 1000
                });
                _this.videoboxDialog = false;
                _this.select_img = '';//选中状态图
                _this.no_select_img = '';//未选中图片
                _this.getlanmulist();
              }
            })

          } else {
            _this.$message({
              message: '请正确填写栏目信息!',
              type: "error",
              duration: 1000,
            });
            return false;
          }
        });
      },


      //获取图片列表
      getImageList(){
        var _this = this;
        let url = '/ac1/conference/spiclist';
        let params = {
          title:'',
        };
        _this.$get(url, params)
          .then((res) => {
          if (parseInt(res.code) === 1)
          {
            _this.imageList = res.posts.list;
          } else
          {
            console.log(res.msg);
          }
        }).catch((error) => {
          console.log(error);
        });
      },

      //保存图片栏目
      saveimagebox(){
        var _this = this;
        this.$refs['imageboxdata'].validate((valid) => {
          if (valid) {
            var url = "/ac1/conference/column/save";
            var params = {
              conference_id:_this.imageboxdata.conference_id,
              id:_this.imageboxdata.id,
              type:_this.imageboxdata.type,
              status:_this.imageboxdata.status,
              list_order:_this.imageboxdata.list_order,
              title:_this.imageboxdata.title,
              is_full:_this.imageboxdata.is_full,
              file_ids:_this.imageboxdata.file_ids,
              pid:_this.imageboxdata.pid,
              isTitleHide:_this.imageboxdata.isTitleHide,
              select_img:_this.select_img,//选中状态图
              no_select_img:_this.no_select_img,//未选中图片
              isNewPage:1,
              isSharePage:1,
            }
            _this.$post(url, params).then(res => {
              if (res.code == 1)
              {
                _this.$message({
                  message: '保存成功',
                  type: 'success',
                  duration: 1000
                });
                _this.imageboxDialog = false;
                _this.select_img = '';//选中状态图
                _this.no_select_img = '';//未选中图片
                _this.getlanmulist();
              }
            })

          } else {
            _this.$message({
              message: '请正确填写栏目信息!',
              type: "error",
              duration: 1000,
            });
            return false;
          }
        });
      },
     }

  };
</script>

<style lang="scss">
  .btn_r{
    float: right;
  }
  #lanmuData{
    input{
      width: 40px;
      text-align: center;
      border: 1px solid #EBEEF5;
    }
  }
  .el-dialog{
    label{
      margin-bottom: 0px;
    }
  }
  .vueueditor{
    line-height: 24px!important;
  }
</style>
